import {createTheme} from "@mui/material/styles";
import {deepmerge} from "@mui/utils";
import themeOptionsDefault from "./default";
import {roRO} from "@mui/material/locale";
import React from "react";
// import shadows, { Shadows } from "@mui/material/styles/shadows";

declare module "@mui/material/styles" {
    // interface Theme {
    //   status: {
    //     danger: string;
    //   };
    // }
    // allow configuration using `createTheme`
    // interface ThemeOptions {
    //   status?: {
    //     danger?: string;
    //   };
    // }
    interface Palette {
        extra: {
            sidebar: React.CSSProperties["color"];
            sidebar_login: React.CSSProperties["color"];
            dashboard_numbers: React.CSSProperties["color"];
        };
        chart: {
            color1: React.CSSProperties["color"];
            color2: React.CSSProperties["color"];
            color3: React.CSSProperties["color"];
            color4: React.CSSProperties["color"];
            color5: React.CSSProperties["color"];
            color6: React.CSSProperties["color"];
            color7: React.CSSProperties["color"];
            color8: React.CSSProperties["color"];
            color9: React.CSSProperties["color"];
        };
    }

    interface PaletteOptions {
        extra: {
            sidebar: React.CSSProperties["color"];
            sidebar_login: React.CSSProperties["color"];
            dashboard_numbers: React.CSSProperties["color"];
        };
        chart: {
            color1: React.CSSProperties["color"];
            color2: React.CSSProperties["color"];
            color3: React.CSSProperties["color"];
            color4: React.CSSProperties["color"];
            color5: React.CSSProperties["color"];
            color6: React.CSSProperties["color"];
            color7: React.CSSProperties["color"];
            color8: React.CSSProperties["color"];
            color9: React.CSSProperties["color"];
        };
    }
}

const theme = createTheme(
    deepmerge(themeOptionsDefault, {
        typography: {
            h1: {
                color: "#00289B",
            },
            h2: {
                color: "#0064FF",
            },
            h3: {
                color: "#777",
            },
            h4: {
                color: "#0064FF",
            },
            h5: {
                color: "#00289B",
            },
            h6: {
                color: "#00289b",
            },
            body1: {
                "& a": {
                    color: "#0064FF",
                    textDecoration: "none",
                },
                "& a:hover, & a:active": {
                    color: "#00289B",
                    textDecoration: "none",
                },
            },
        },
        palette: {
            mode: "light",
            primary: {main: "#00289B", dark: "#0064FF", light: "#98C0FF", contrastText: "#fff"},
            secondary: {main: "#00289B", light: "#0064FF", dark: "#00289B", contrastText: "#fff"},
            // error: { main: "#9D0000", light: "#ED0000", dark: "#6E2121" },
            error: {main: "#9D0000", light: "#e20613", dark: "#f4c7c7"},
            warning: {main: "#DE6525", dark: "#ffe2b7", light: "#e2cab6"},
            info: {main: "#98C0FF", light: "#fff", dark: "#00289B", contrastText: "#0064FF"},
            success: {main: "#059669", light: "#00BA3B", dark: "#cce8cd"},
            text: {
                primary: "#00289b",
                secondary: "#00289b",
                info: "#0064FF",
                disabled: "#777777",
            },
            background: {
                paper: "#D7E6FF",
                default: "#fff",
                light: "#fff",
            },
            divider: "#efefef",
            extra: {
                sidebar: "#EFEFEF",
                sidebar_login: "rgba(255, 255, 255, 0.7)",
                dashboard_numbers: "rgba(255, 255, 255, 0.5)",
            },
            chart: {
                color1: "#e2cab6",
                color2: "#cbd5e1",
                color3: "#9cbbf3",
                color4: "#a4c9c3",
                color5: "#D97707",
                color6: "#94A3B8",
                color7: "#0164FF",
                color8: "#069668",
                color9: "#94A3B8",
            },
        },
    }),
    roRO,
);

// theme.typography.h1 = {
//   ...theme.typography.h1,
//   fontSize: "2.75rem",
//   marginBottom: 32,
//   [theme.breakpoints.up("sm")]: {
//     fontSize: "3rem",
//     marginBottom: 48,
//   },
//   [theme.breakpoints.up("md")]: {
//     fontSize: "3.5rem",
//     marginBottom: 56,
//   },
//   [theme.breakpoints.up("lg")]: {
//     fontSize: "4rem",
//     marginBottom: 64,
//   },
// };

// theme.typography.h2 = {
//   ...theme.typography.h2,
//   fontSize: "2rem",
//   "& strong": {
//     fontSize: "2.25rem",
//     fontWeight: 100,
//   },
//   [theme.breakpoints.up("sm")]: {
//     fontSize: "2.25rem",
//     "& strong": {
//       fontSize: "2.5rem",
//     },
//   },
//   [theme.breakpoints.up("md")]: {
//     fontSize: "2.5rem",
//     "& strong": {
//       fontSize: "2.75rem",
//     },
//   },
//   [theme.breakpoints.up("lg")]: {
//     fontSize: "2.75rem",
//     "& strong": {
//       fontSize: "3rem",
//     },
//   },
// };

// theme.typography.h5 = {
//   ...theme.typography.h5,
//   marginBottom: 16,
//   [theme.breakpoints.up("sm")]: {
//     marginBottom: 24,
//   },
//   [theme.breakpoints.up("md")]: {
//     marginBottom: 32,
//   },
//   [theme.breakpoints.up("lg")]: {
//     marginBottom: 40,
//   },
// };

// theme.typography.body1 = {
//   ...theme.typography.body1,
//   fontSize: "1.125rem",
//   lineHeight: 1.3,
//   [theme.breakpoints.up("sm")]: {
//     fontSize: "1.125rem",
//   },
//   [theme.breakpoints.up("md")]: {
//     fontSize: "1.125rem",
//   },
//   [theme.breakpoints.up("lg")]: {
//     fontSize: "1.125rem",
//     lineHeight: 1.2,
//   },
// };

export default theme;
